import ActionsForm from '@/shared/mixins/actionsForm'
import ApruserRepository from '@/shared/http/repositories/business/qmaTemplate.js'
import { loading } from '@/shared/utils/UIHelper'

export default {
  name: 'logTemplateQma',
  mixins: [ActionsForm],
  components: {},
  data () {
    return {
      serachiput: '',
      dataTemplateLogQMA: []
    }
  },

  props: ['templateid'],

  watch: {
  },

  mounted () {
    this.GetLog(this.templateid)
  },
  methods: {
    GetLog (value) {
      ApruserRepository.GetLogQma(value)
        .then((Response) => {
          this.dataTemplateLogQMA = Response.data.data
          loading.pop()
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/qmaTemplate/detailsTemplate/tabsTemplate/components/logTemplateQma/logTemplateQma.js